module.exports = __webpack_public_path__ + "static/hfs-national-23e10c08ad979b8c42493e4bf02f4199.png";